import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

const icon = (name: string, folder: 'navbar' | 'components' = 'navbar') => (
  <SvgColor src={`/assets/icons/${folder}/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

export const ICONS = {
  box: icon('ic_box'),
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  supplier: <Iconify icon="solar:buildings-2-bold-duotone" sx={{ width: 1, height: 1 }} />,
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  products: icon('ic_products'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  documentAdd: icon('ic_document_add'),
  formValidation: icon('ic_extra_form_validation', 'components'),
  settings: icon('ic_settings'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // DASHBOARDS
      // ----------------------------------------------------------------------
      {
        subheader: 'Dashboards',
        items: [
          { title: 'Daily Overview', path: paths.dailyOverview.root, icon: ICONS.dashboard },
          { title: 'Business Overview', path: paths.businessOverview.root, icon: ICONS.analytics },
          { title: 'Inventory Health', path: paths.inventoryHealth.root, icon: ICONS.analytics },
        ],
      },

      {
        subheader: 'Inventory',
        items: [
          { title: 'Purchase Orders', path: paths.purchaseorders.root, icon: ICONS.ecommerce },
          { title: 'Fulfillments', path: paths.fulfillments.root, icon: ICONS.order },
          { title: 'Stock Changes', path: paths.stockChanges.root, icon: ICONS.documentAdd },
        ],
      },

      {
        subheader: 'Management',
        items: [
          {
            title: 'Products',
            path: paths.products.root,
            icon: ICONS.file,
            children: [
              { title: 'Catalog', path: paths.products.list },
              { title: 'Analytics', path: paths.products.analytics },
            ],
          },
          {
            title: 'Suppliers',
            path: paths.suppliers.root,
            icon: ICONS.supplier,
            children: [
              { title: 'List', path: paths.suppliers.list },
              { title: 'Performance', path: paths.suppliers.performance },
            ],
          },
          { title: 'Warehouses', path: paths.warehouses.root, icon: ICONS.banking },
          { title: 'Utilities', path: paths.utilities.root, icon: ICONS.products },
        ],
      },
      {
        subheader: 'Automation',
        items: [
          { title: 'Recommendations', path: paths.recommendations.root, icon: ICONS.label },
          { title: 'Rules', path: paths.rules.root, icon: ICONS.formValidation },
        ],
      },
      // {
      //   subheader: 'Configuration',
      //   items: [
      //     {
      //       title: 'Settings',
      //       path: paths.settings.root,
      //       icon: ICONS.settings,
      //       children: [
      //         { title: 'General', path: paths.settings.general },
      //         { title: 'Billing', path: paths.settings.billing },
      //       ],
      //     },
      //   ],
      // },
    ],
    []
  );

  return data;
}
